module.exports = __webpack_public_path__ + "static/media/Simbolo_Adroit.e91ffbae.png";